import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom'
import { createBrowserHistory } from 'history'


import Tests from '../commons/Tests'
import Login from '../module/login/Login'
import Settings from '../module/settings/Settings';


import LS from '../providers/LocalStorage'
import '../App.css';
import LocalStorage from '../providers/LocalStorage';
import Test from '../module/teste/Test';
import Home from '../module/home/Home';
import Projects from '../module/projects/Projects';
import DetaliiProiect from '../module/projects/DetaliiProiect';
import SignUp from '../module/signup/SignUp';
import Useri from '../module/useri/Useri';
import InfoUser from '../module/useri/InfoUser';
import Nomenclatoare from '../module/nomenclatoare/Nomenclatoare';
import FinanciarContabil from '../module/financiar/FinanciarContabil';
import ParametruBilant from '../module/financiar/ParametruBilant';
import Organigrama from '../commons/Organigrama';
import OrganigramaRoute from '../module/organigrama/OrganigramaRoute';
import UserEtape from '../module/useri/UserEtape';
import UserProiecte from '../module/useri/UserProiecte';
import Rapoarte from '../module/rapoarte/Rapoarte';
import RapoartePeUtilizatori from '../module/rapoarte/RapoartePeUtilizatori';
import RapoarteTimp from '../module/rapoarte/RapoarteTimp';
import RapoarteProiect from '../module/projects/RapoarteProiect';
import RaportComparativProiecte from '../module/rapoarte/RaportComparativProiecte';
import Administrare from '../module/administrare/Administrare';
import Mesagerie from '../module/administrare/Mesagerie';
import IstoricIndicatoriFinanciari from '../module/financiar/IstoricIndicatoriFinanciari';
import BalanteBilanturi from '../module/financiar/BalanteBilanturi';
import Planificare from '../module/financiar/Planificare';
import Beneficiari from '../module/beneficiari/Beneficiari';
import Test2 from '../module/teste/Test2.js';
import ARF from '../module/financiar/ARF/ARF';
import SoldFurnizor from '../module/financiar/ARF/SoldFurnizor';
import SoldClienti from '../module/financiar/ARF/SoldClienti';
import Bilant from '../module/financiar/ARF/Bilant';
import ACF from '../module/financiar/ACF/ACF';
import FluxNumerar from '../module/financiar/ACF/FluxNumerar';
import CheltuieliSiCosturi from '../module/financiar/ACF/CheltuieliSiCosturi';
import PlanificareSiPrognoza from '../module/financiar/ACF/PlanificareSiPrognoza';
import AnalizeProfitSiPierdere from '../module/financiar/ACF/AnalizeProfitSiPierdere';
import VenituriSiPreviziuni from '../module/financiar/ACF/VenituriSiPreviziuni';
import CursuriSiIndiciBursieri from '../module/financiar/ACF/CursuriSiIndiciBursieri';
import ARP from '../module/financiar/ARP/ARP';
import AnalizaProiectelor from '../module/financiar/ARP/AnalizaProiectelor';
import AnalizaAngajatilor from '../module/financiar/ARP/AnalizaAngajatilor';
import CursuriFinanciare from '../module/financiar/ARP/CursuriFinanciare';
import IndiciBursieri from '../module/financiar/ARP/IndiciBursieri';
import ARS from '../module/financiar/ARS/ARS';
import AVC from '../module/financiar/AVC/AVC';
import AnalizaClientilorNoi from '../module/financiar/AVC/AnalizaClientilorNoi';
import ClientiNoiCastigatiLunar from '../module/financiar/AVC/ClientiNoiCastigariLunar';
import TrendPastrareClienti from '../module/financiar/AVC/TrendPastrareClienti';
import SegmentareaClientilorStare from '../module/financiar/AVC/SegmentareaClientilorStare';
import ClientiPierduti from '../module/financiar/AVC/ClientiPierduti';
import ClientiCastigati from '../module/financiar/AVC/ClientiCastigati';
import ClientiActivi from '../module/financiar/AVC/ClientiActivi';
import ClientiLoiali from '../module/financiar/AVC/ClientiLoiali';
import SegmentareaClientilorCaracteristici from '../module/financiar/AVC/SegmentareaClientilorCaracteristici';
import Educatie from '../module/financiar/AVC/Educatie';
import ClasaSociala from '../module/financiar/AVC/ClasaSociala';
import Limba from '../module/financiar/AVC/Limba';
import Nationalitate from '../module/financiar/AVC/Nationalitate';
import MembriiFamilie from '../module/financiar/AVC/MembriiFamilie';
import Ocupatie from '../module/financiar/AVC/Ocupatie';
import Rasa from '../module/financiar/AVC/Rasa';
import Religie from '../module/financiar/AVC/Religie';
import Sex from '../module/financiar/AVC/Sex';
import StilViata from '../module/financiar/AVC/StilViata';
import Venit from '../module/financiar/AVC/Venit';
import AnalizaVanzarilorCrossSell from '../module/financiar/AVC/AnalizaVanzarilorCrossSell';
import CecuriSiBileteOrdine from '../module/financiar/CecuriSiBileteOrdine';
import Pontaj from '../module/pontaj/Pontaj';
import CarCalendar from '../module/teste/CarCalendar';
import PontajColectiv from '../module/pontaj/PontajColectiv';
import NewProject from '../module/projects/NewProject';
import DocumenteProiecte from '../module/projects/DocumenteProiecte';
import Economic from '../module/projects/Economic';
import EconomicDetalii from '../module/projects/EconomicDetalii';
import ManagementUtilizatori from '../module/administrare/ManagementUtilizatori';
import ManagementUtilizator from '../module/administrare/ManagementUtilizator';
import ChestionareEvaluari from '../module/chestionare/ChestionareEvaluari';
import ChestionarNou from '../module/chestionare/ChestionarNou';
import CreeazaChestionar from '../module/chestionare/CreeazaChestionar';
import EvaluariColegi from '../module/chestionare/EvaluariColegi';
import EvaluareNouaColegi from '../module/chestionare/EvaluareNouaColegi';
import EvaluariSefi from '../module/chestionare/EvaluariSefi';
import EvaluariClienti from '../module/chestionare/EvaluariClienti';
import EvaluareNouaSefi from '../module/chestionare/EvalualreNouaSefi';
import EvaluareNouaClienti from '../module/chestionare/EvaluareNouaClienti';
import EvaluariSesiune from '../module/chestionare/EvaluariSesiune';
import EvaluariGenerale from '../module/chestionare/EvaluariGenerale';
import EvaluareNouaGenerala from '../module/chestionare/EvaluareNouaGenerala';
import CompletatorChestionar from '../module/chestionare/CompletatorChestionar';
import PontajColectivNew from '../module/pontaj/PontajColectivNew';
import AngajatiCandidati from '../module/pontaj/AngajatiCandidati';
import FisaPersonalaAngajat from '../module/pontaj/FisaPersonalaAngajat';
import Candidati from '../module/pontaj/Candidati';
import DocumenteHr from '../module/pontaj/DocumenteHr';
import MonitorizareDaily from '../module/monitorizare/MonitorizareDaily';
import MonitorizareAngajat from '../module/monitorizare/MonitorizareAngajat';
import RaportareLunara from '../module/monitorizare/RaportareLunara';
import ListaBilanturi from '../module/financiarn/ListaBilanturi';
import BilantNou from '../module/financiarn/BilantNou';
import BilantRows from '../module/financiarn/BilantRows';
import DiagnosticFinanciar from '../module/financiarn/DiagnosticFinanciar';
import DateDespreBilant from '../module/financiarn/DateDespreBilant';
import ClientiRows from '../module/financiarn/ClientiRows';
import DateDespreClient from '../module/financiarn/DateDespreClient';
import ArhivaProiecte from '../module/projects/ArhivaProiecte';
import RapoartePontaj from '../module/pontaj/RapoartePontaj';
import RaportPersonal from '../module/pontaj/RaportPersonal';
import MonitorizareAngajatNew from '../module/monitorizare/MonitorizareAngajatNew';
import AdminBeneficiari from '../module/AdminBeneficiari/AdminBeneficiari';
import LoginExt from '../module/login/LoginExt';


export const history = createBrowserHistory({
        basename: process.env.PUBLIC_URL
});

export default class Routes extends React.Component {
        constructor(props) {
                super(props);
                this.state = { esteLogat: false }
        }

        componentDidMount() {

                let localStorage = new LocalStorage();
                let ud = new LS().GetUserData()
                // console.log('ud = ', ud)

                if (ud)
                        this.setState({ esteLogat: true })
                else
                        this.setState({ esteLogat: false })
        }

        render() {
                return (
                        <div className="App">
                                <HashRouter>
                                        <Switch>


                                                <Route exact path='/test' component={Test} history={history} />
                                                <Route exact path='/test2' component={Test2} history={history} />
                                                <Route exact path='/signup' component={SignUp} />

                                                <Route exact path='/completator/:idinvitatie' component={CompletatorChestionar} />
                                                <Route exact path='/adminbeneficiari/adminbogdanrfgt987hjyt652210kjyewqlmpsty325h' component={AdminBeneficiari} history={history} />


                                                <Route exact path='/managementutilizator' component={ManagementUtilizator} history={history} />

                                                <Route exact path='/loginext/:usr/:pass' component={LoginExt} />
                                                {!this.state.esteLogat &&
                                                        <Route path='/' component={Login} />
                                                }



                                                {this.state.esteLogat &&
                                                        <Route exact path='/' component={Home} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/projects' component={Projects} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/projectdetails/:projectid/:projectsegment' component={DetaliiProiect} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/tests' component={Tests} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/settings' component={Settings} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/users' component={Useri} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/infouser/:iduser' component={InfoUser} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/nomenclatoare' component={Nomenclatoare} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/financiarcontabil' component={FinanciarContabil} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/parametrubilant/:idhead' component={ParametruBilant} history={history} />
                                                }

                                                {/* {this.state.esteLogat &&
                                                        <Route exact path='/evaluareactivitati' component={Chestionare} history={history} />
                                                } */}

                                                {/* {this.state.esteLogat &&
                                                        <Route exact path='/detaliieval/:ideval' component={DetaliiEvaluari} history={history} />
                                                } */}

                                                {this.state.esteLogat &&
                                                        <Route exact path='/organigrama' component={OrganigramaRoute} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/useretape/:iduser/:idproiect' component={UserEtape} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/userprojects/:iduser' component={UserProiecte} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/rapoarte' component={Rapoarte} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/rapoarteutilizatori' component={RapoartePeUtilizatori} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/rapoartetimp' component={RapoarteTimp} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/rapoarateproiecte' component={RaportComparativProiecte} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/administrare' component={Administrare} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/messenger' component={Mesagerie} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/istoricindicatiorifinanciari' component={IstoricIndicatoriFinanciari} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/balantebilanturi' component={BalanteBilanturi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/planificare' component={Planificare} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/beneficiari' component={Beneficiari} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/arf' component={ARF} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/soldfurnizori' component={SoldFurnizor} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/soldclienti' component={SoldClienti} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/bilant' component={Bilant} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/acf' component={ACF} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/fluxnumerar' component={FluxNumerar} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/cheltuielisicosturi' component={CheltuieliSiCosturi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/planificareprognoza' component={PlanificareSiPrognoza} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/analizaprofitpierdere' component={AnalizeProfitSiPierdere} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/venituripreviziuni' component={VenituriSiPreviziuni} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/cursurisiindici' component={CursuriSiIndiciBursieri} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/arp' component={ARP} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/analizaproiectelor' component={AnalizaProiectelor} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/analizaangajatilor' component={AnalizaAngajatilor} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/cursurifinanciare' component={CursuriFinanciare} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/indicibursieri' component={IndiciBursieri} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/ars' component={ARS} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/avc' component={AVC} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/analizaclientilornoi' component={AnalizaClientilorNoi} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clientilunar' component={ClientiNoiCastigatiLunar} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/trendpastrareclienti' component={TrendPastrareClienti} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/segmentareclienti' component={SegmentareaClientilorStare} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clientipierduti' component={ClientiPierduti} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clienticastigati' component={ClientiCastigati} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clientiactivi' component={ClientiActivi} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clientiloiali' component={ClientiLoiali} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/segmentareaclientilorcaracteristici' component={SegmentareaClientilorCaracteristici} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/educatie' component={Educatie} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/clasasociala' component={ClasaSociala} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/limba' component={Limba} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/nationalitate' component={Nationalitate} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/membriifamilie' component={MembriiFamilie} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/ocupatie' component={Ocupatie} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/rasa' component={Rasa} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/religie' component={Religie} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/sex' component={Sex} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/stilviata' component={StilViata} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/venit' component={Venit} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/maimult/:idhead' component={ParametruBilant} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/analizavanzarilor' component={AnalizaVanzarilorCrossSell} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/bileteordin' component={CecuriSiBileteOrdine} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/pontaj/:iduser' component={Pontaj} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/pontaje' component={PontajColectivNew} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/operatiuni' component={AngajatiCandidati} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/candidati' component={Candidati} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/documentehr' component={DocumenteHr} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/fisapersonalaangajat/:idAngajat' component={FisaPersonalaAngajat} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/newproject/:idproiect' component={NewProject} history={history} />


                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/documenteproiecte' component={DocumenteProiecte} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/economic' component={Economic} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/economicdetalii/:idproiect' component={EconomicDetalii} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/managementutilizatori' component={ManagementUtilizatori} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/managementutilizator' component={ManagementUtilizator} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/chestionareevaluari/:idsesiune/:tip' component={ChestionareEvaluari} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/chestionarnou/:idsesiune/:tip' component={ChestionarNou} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/chestionardetalii/:idchestionar/:idsesiune/:tip' component={CreeazaChestionar} history={history} />
                                                }


                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluaricolegi' component={EvaluariColegi} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarisefi' component={EvaluariSefi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluariclienti' component={EvaluariClienti} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarigenerale' component={EvaluariGenerale} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarenouacolegi/:idsesiune/:idevaluare' component={EvaluareNouaColegi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarenouasefi/:idsesiune/:idevaluare' component={EvaluareNouaSefi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarenouaclienti/:idsesiune/:idevaluare' component={EvaluareNouaClienti} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarenouagenerala/:idsesiunecolegi/:idsesiunesefi/:idsesiuneclienti' component={EvaluareNouaGenerala} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/evaluarisesiune/:idsesiune/:tip' component={EvaluariSesiune} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/monitorizaredaily' component={MonitorizareDaily} history={history} />
                                                }
                                                {this.state.esteLogat &&
                                                        <Route exact path='/monitorizareraportare' component={RaportareLunara} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/monitorizareangajat/:idAngajat' component={MonitorizareAngajatNew} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/managementbilanturi' component={ListaBilanturi} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/bilantnou' component={BilantNou} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/bilantrows/:idBilant' component={BilantRows} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/diagnosticfinanciar' component={DiagnosticFinanciar} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/datedesprebilant/:idBilant' component={DateDespreBilant} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/clientirows/:idClientiHead' component={ClientiRows} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/datedespreclient/:idClient' component={DateDespreClient} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/arhivaproiecte' component={ArhivaProiecte} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/rapoartepontaj' component={RapoartePontaj} history={history} />
                                                }

                                                {this.state.esteLogat &&
                                                        <Route exact path='/raportpersonal/:idAngajat' component={RaportPersonal} history={history} />
                                                }




                                                <Route exact path='/cartest' component={CarCalendar} history={history} />





                                        </Switch>
                                </HashRouter>
                        </div>
                );
        }


}  // end class